import { Box } from '@mui/material';
import { lazy } from 'react';
import { VM } from '../../../core/VM';
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import { Suspense } from 'react';
import { SnakeLoader } from '../../../core/loader/SnakeLoader';
import { Logo } from '../../../core/global/Icons';
import { DbProvider } from '../../../db/db-context';
import { useEffect } from 'react';
import { modalTriggeredDB } from '../../../db/Index';
import { ToolContext } from '../../../core/context/ToolContext';
import { useContext } from 'react';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';

let view = VM();
const Navigation = lazy(() => import(`./layouts/navigations${view}/Index`));
const Home = lazy(() => import(`./dashboard${view}/Index`));
const Trainings = lazy(() => import(`./trainings${view}/Index`));
const Preview = lazy(() => import(`./preview${view}/Index`));
const Take = lazy(() => import(`./take${view}/Index`));


export const UBR = () => {
    console.log(`POFAcademy UBR V1.02.06 is running`)
    return (
        <DbProvider>
            <Router>
                <Suspense
                    fallback={
                        <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            <Logo size={60} />
                            <Box mt={4}>
                                <SnakeLoader size="1rem" bg="#3D77E9" distance="0.3rem" />
                            </Box>
                        </Box>
                    }
                >
                    <Switch>
                        {/* Home */}
                        <Route exact path="/" render={(props) => <Render Component={Home} {...props} />} />
                        {/* Trainings */}
                        <Route exact path="/trainings/:tab" render={(props) => <Render Component={Trainings} {...props} />} />
                        {/* PREVIEW */}
                        <Route exact path="/preview" render={(props) => <Render Component={Preview} {...props} />} />
                        {/* TAKE TRAINING COURSE */}
                        <Route exact path="/take-training-course/:tab" render={(props) => <Render Component={Take} {...props} />} />
                    </Switch>
                </Suspense>
            </Router>
        </DbProvider>
    );
};

const Render = ({ Component, ...props }) => {
    const location = useLocation();
    const { ubr_state, tool_state } = useContext(ToolContext)
    const showSidebar =
        ![
            "/take-training-course/pretest",
            "/take-training-course/quiz",
            "/take-training-course/video-lesson",
            "/take-training-course/post-evaluation",
        ].includes(location.pathname);


    
    const __intit = async()=> {
        try {
            // Check if record with ID 1 exists
            const existingRecord = await modalTriggeredDB.modalTriggered
                .where("id")
                .equals(1)
                .first();

            if (existingRecord) {
                ubr_state.wc.set(existingRecord.dashboard);
                ubr_state.openT.set(existingRecord.trainings);
                ubr_state.mnt.set(existingRecord.maintenance);
            } else {

                await modalTriggeredDB.modalTriggered.add({
                    id: 1, // Explicitly set ID
                    dashboard: true,
                    trainings: false,
                    maintenance: false,
                });
                console.log("New record added successfully.");
            }
        } catch (error) {
            console.error("Error accessing or updating the database:", error);
        }

        let prof = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/profession/read`,{filter:'all'})
        let compileData = [...tool_state.profession.data, ...prof]
        tool_state.profession.set(compileData)
    }   
    useEffect(() => {
        __intit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {view === "" ? (
                <Box width="100%" height="100%">
                    <Box width="100%" height="100%" display="flex">
                        <Box height="100%">
                            {showSidebar && <Navigation side={1} />}
                        </Box>
                        <Box display="flex" flexDirection="column" width="100%" height="100%">
                            <Navigation side={0} />
                            <Box height="100%" className="overflowY noScrollcss">
                                <Component {...props} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box width="100%" height="100%">
                    <Box width="100%" height="100%" display="flex" flexDirection="column">
                        {(location.pathname !== '/profiling' && location.pathname !== '/more' && location.pathname !== '/certificates/recently/removed') && (
                            <Box minHeight={location.pathname === '/' ? '92px' : '40px'}>
                                <Navigation side={0} />
                            </Box>
                        )}
                        <Box height="100%" width="100%" className="overflowY noScrollcss">
                            <Component {...props} />
                        </Box>
                        {(location.pathname !== '/profile' && location.pathname !== '/profiling' && location.pathname !== '/certificates/recently/removed') && (
                            <Box minHeight="54px">
                                <Navigation side={2} />
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};
